import tracking from './index';

document.addEventListener('tracking.init', event => {
    tracking.init(event.detail.key);
});

document.addEventListener('tracking.track', event => {
    tracking.track(event.detail.event, event.detail.properties || null, event.detail.options || null);
});

document.addEventListener('tracking.trackPage', event => {
    tracking.trackPage(event.detail.url);
});

document.addEventListener('tracking.page', event => {
    tracking.page(event.detail);
});

document.addEventListener('tracking.trackForm', event => {
    tracking.trackForm(event.detail.event, event.detail.properties || null, event.detail.identifyProperties || null, event.detail.options || null);
});

document.addEventListener('tracking.identify', event => {
    tracking.identify(event.detail.userId, event.detail.traits || null);
});

document.addEventListener('tracking.identifyFromLocalStorage', () => {
    tracking.identifyFromLocalStorage();
});

document.addEventListener('tracking.alias', event => {
    tracking.alias(event.detail.userId);
});

document.addEventListener('tracking.reset', () => {
    tracking.reset();
});

document.dispatchEvent(new CustomEvent('tracking.ready'));



// WEBPACK FOOTER //
// ./src/browser.js